import { Link } from "react-router-dom";
import { Project } from "../../types/project";
import { ProjectVisual } from "./ProjectVisual";
export function ProjectCard({
  project,
  index,
}: {
  project: Project;
  index: number;
}) {
  return (
    <article className={`project project-${index + 1}`} data-reveal>
      <Link
        to={`/work/${project.slug}`}
        className="project-image-link"
        aria-label={`Read ${project.name} case study`}
      >
        <ProjectVisual project={project} />
        <span className="project-view">Explore project ↗</span>
      </Link>
      <div className="project-info">
        <div>
          <span className="project-category">
            {String(index + 1).padStart(2, "0")} / {project.category}
          </span>
          <h3>
            <Link to={`/work/${project.slug}`}>
              {project.name}
              <span aria-hidden="true">↗</span>
            </Link>
          </h3>
          <p>{project.summary}</p>
        </div>
        <div className="tags">
          {project.tags.map((tag) => (
            <span key={tag}>{tag}</span>
          ))}
        </div>
      </div>
    </article>
  );
}
